module.exports = __webpack_public_path__ + "static/media/snowy-6.67d63a14.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/weather-icons/snowy-6.svg
// module id = 531
// module chunks = 0